import { render, staticRenderFns } from "./ContactPageTable.vue?vue&type=template&id=77f13233&scoped=true&"
import script from "./ContactPageTable.vue?vue&type=script&lang=js&"
export * from "./ContactPageTable.vue?vue&type=script&lang=js&"
import style0 from "./ContactPageTable.vue?vue&type=style&index=0&id=77f13233&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f13233",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
